import { render, staticRenderFns } from "./MockForm.vue?vue&type=template&id=8775627a&"
import script from "./MockForm.vue?vue&type=script&lang=js&"
export * from "./MockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports